import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { CurrentUser } from '../core/models/currentUser.model';
import { DOCUMENT } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MyProfileComponent } from '../core/my-profile/my-profile.component';
import { DirtyTrackingService } from '../core/dirty-tracking/dirty-tracking.service';
import { RouterExtService } from '../core/services/router-ext.service';

@Component({
  selector: 'app-admin-root',
  templateUrl: './admin-root.component.html',
  styleUrls: []
})
export class AdminRootComponent implements OnInit {

  currentUser: CurrentUser = new CurrentUser();
  doneLoading: boolean = false;
  currentMenu: string = '';
  showMobile: boolean = false;

  constructor(@Inject(DOCUMENT) private document: Document,
    private modalService: NgbModal,
    private ajax: ajaxCall,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private dirtyService: DirtyTrackingService,
    private routerExtService: RouterExtService) {
    this.document.body.classList.add('admin');
  }

  ngOnDestroy(): void {
    this.document.body.classList.remove('admin');
  }

  ngOnInit(): void {
    this.ajax.MakeCall<CurrentUser>('/User/Current').then(data => {
      if (!data.userId) {
        this.router.navigateByUrl('/login?returnUrl=' + window.location.pathname);
        return;
      } else if (!data.isPDxAdmin) {
        window.location.href = window.location.origin + '/customer';
        return;
      }
      this.currentUser = data;
      this.doneLoading = true;
    });

    this.router.events.subscribe((event: NavigationEnd) => {
      this.setCurrentRoute();
    });
    this.setCurrentRoute();
  }

  setCurrentRoute(): void {
    var a = this.activeRoute;
    while (a.children.length > 0) {
      a = a.children[0];
    }

    this.currentMenu = a.snapshot.data.highlighted;
  };

  logout(): void {
    this.ajax.MakeCall<void>('/Login/Logout').then(() => {
      this.router.navigateByUrl('/login');
    });

  }

  editMyProfile(): void {
    const modal = this.modalService.open(MyProfileComponent, { beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.result.then(cUser => { this.currentUser = cUser; }, () => { });
  }

}
